import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TGpsrApi } from './types';

export const gpsr: TGpsrApi = {
	getProductType: (params) =>
		http
			.get(endpoint.gpsr.GET_PRODUCT_TYPE(params.productTypeId))
			.then((response) => response.data),
	getSku: (params) =>
		http
			.get(endpoint.gpsr.GET_SKU(params.productTypeId), { params: params.body })
			.then((response) => response.data),
	downloadFile: (params) =>
		http
			.get(endpoint.gpsr.GET_FILE(params.productTypeId), {
				responseType: 'blob',
			})
			.then((response) => response.data),
};
